import { FC } from "react";
import { ChatHeaderProps } from "./types";
import { Row } from "../../../components/containers";
import {
  AlignItems,
  JustifyContent,
} from "../../../components/containers/types";
import { SearchInput } from "../../../components/inputs";
import ChatUserList from "../chat-user-list";

const ChatHeader: FC<ChatHeaderProps> = ({
  isMobile,
  isSidePanel,
  searchTerm = "",
  setSearchTerm = () => {},
  headerRef,
}) => {
  return (
    <Row
      containerRef={headerRef}
      style={{ width: "100%", flexFlow: !isMobile ? "row" : "column-reverse" }}
      justifyContent={JustifyContent.Between}
      alignItems={isMobile ? AlignItems.Center : AlignItems.End}
      gap={20}
    >
      <ChatUserList isMobile={isMobile} isSidePanel={isSidePanel} />
      <Row style={{ maxWidth: 320, height: 55, width: "100%" }}>
        <SearchInput value={searchTerm} setValue={setSearchTerm} />
      </Row>
    </Row>
  );
};

export default ChatHeader;
